import { planName, planRank } from '@dale/plans';

import type { PlanTier } from '../../lib/plan';
import { LockGlyph } from '../PlanLocked';

/**
 * A page's name in the nav, with a small lock when the business's plan does
 * not include it: the door stays where it always is, and says which plan
 * opens it (on hover, and to screen readers). `decorative` drops the spoken
 * part for a copy that is already hidden from assistive tech.
 */
export function NavLabel({ label, lock, decorative = false }: { label: string; lock?: PlanTier; decorative?: boolean }) {
  return (
    <>
      {label}
      {lock && !decorative ? <span className="sr-only">, disponible en {planName(lock)}</span> : null}
      {lock ? (
        <span className="nav-lock" title={`Disponible en ${planName(lock)}`} aria-hidden="true">
          <LockGlyph />
        </span>
      ) : null}
    </>
  );
}

/** A folder carries the lock only when every page in it is locked; then it names the cheapest plan that opens one. */
export function folderLock(links: readonly { lock?: PlanTier }[]): PlanTier | undefined {
  const locks = links.map((link) => link.lock);
  if (locks.length === 0 || locks.some((lock) => lock === undefined)) return undefined;
  return locks.reduce<PlanTier | undefined>((cheapest, lock) => (cheapest === undefined || (lock && planRank(lock) < planRank(cheapest)) ? lock : cheapest), undefined);
}
